// extracted by mini-css-extract-plugin
module.exports = {"displayTimeInDecimalContainer":"TimeInOrganizationalUnitsReportContent_displayTimeInDecimalContainer__3imoK"};